// // AdminExpensesReport.jsx
// import React, { useState, useEffect, useCallback } from 'react';
// import {
//   getAdminExpenses,
//   getAdminExpenseById,
//   createAdminExpense,
//   updateAdminExpense,
//   deleteAdminExpense,
//   approveAdminExpense,
//   getAdminExpenseCategories,
//   getAdminExpenseDepartments,
//   getAdminExpenseStats
// } from '../../Services/Operations/ProductAPI';
// import '../../Styles/ManagementPages.css';
// import { useSelector } from 'react-redux';

// const AdminExpensesReport = () => {
//   const [expenses, setExpenses] = useState([]);
//   const [summary, setSummary] = useState(null);
//   const [categoryBreakdown, setCategoryBreakdown] = useState([]);
//   const [departmentBreakdown, setDepartmentBreakdown] = useState([]);
//   const [monthlyBreakdown, setMonthlyBreakdown] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewingExpense, setViewingExpense] = useState(null);
//   const [editingExpense, setEditingExpense] = useState(null);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [error, setError] = useState(null);
//   const { token } = useSelector(state => state.user);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalItems, setTotalItems] = useState(0);
//   const [pageSize] = useState(10);

//   // Filter states
//   const [filters, setFilters] = useState({
//     startDate: '',
//     endDate: '',
//     category: '',
//     department: '',
//     paymentStatus: '',
//     approvalStatus: '',
//     priority: '',
//     minAmount: '',
//     maxAmount: '',
//     vendorName: ''
//   });
//   const [showFilters, setShowFilters] = useState(false);
//   const [isFiltered, setIsFiltered] = useState(false);

//   // Sorting states
//   const [sortBy, setSortBy] = useState('expenseDate');
//   const [sortOrder, setSortOrder] = useState('desc');

//   // Form state
//   const [formData, setFormData] = useState({
//     title: '',
//     description: '',
//     category: '',
//     department: 'admin',
//     amount: '',
//     taxAmount: '',
//     discountAmount: '',
//     paymentMethod: 'bank_transfer',
//     paymentStatus: 'pending',
//     expenseDate: new Date().toISOString().split('T')[0],
//     vendorName: '',
//     vendorPhone: '',
//     vendorEmail: '',

//     priority: 'medium',
//     notes: ''
//   });

//   // Fetch categories and departments on mount
//   useEffect(() => {
//     fetchCategories();
//     fetchDepartments();
//   }, []);

//   // Debounced fetch
//   const debouncedFetch = useCallback(() => {
//     const timeoutId = setTimeout(() => {
//       fetchExpenses();
//     }, 500);
//     return () => clearTimeout(timeoutId);
//   }, [currentPage, searchTerm, filters, sortBy, sortOrder]);

//   useEffect(() => {
//     const cleanup = debouncedFetch();
//     return cleanup;
//   }, [debouncedFetch]);

//   const fetchCategories = async () => {
//     try {
//       const response = await getAdminExpenseCategories(token);
//       if (response && response.success) {
//         setCategories(response.data);
//       }
//     } catch (error) {
//       console.error('Error fetching categories:', error);
//     }
//   };

//   const fetchDepartments = async () => {
//     try {
//       const response = await getAdminExpenseDepartments(token);
//       if (response && response.success) {
//         setDepartments(response.data);
//       }
//     } catch (error) {
//       console.error('Error fetching departments:', error);
//     }
//   };

//   const fetchExpenses = async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       const filterParams = {};

//       if (searchTerm && searchTerm.trim()) {
//         filterParams.search = searchTerm.trim();
//       }

//       Object.keys(filters).forEach(key => {
//         if (filters[key] && filters[key] !== '') {
//           filterParams[key] = filters[key];
//         }
//       });

//       const params = {
//         page: currentPage,
//         limit: pageSize,
//         sortBy: sortBy,
//         sortOrder: sortOrder,
//         ...filterParams
//       };

//       const response = await getAdminExpenses(params, token);

//       if (response && response.success) {
//         setExpenses(response.data.expenses || []);
//         setSummary(response.data.summary);
//         setCategoryBreakdown(response.data.categoryBreakdown || []);
//         setDepartmentBreakdown(response.data.departmentBreakdown || []);
//         setMonthlyBreakdown(response.data.monthlyBreakdown || []);
//         setTotalPages(response.data.pagination?.totalPages || 1);
//         setTotalItems(response.data.pagination?.totalItems || 0);

//         const hasActiveFilters =
//           (searchTerm && searchTerm.trim() !== '') ||
//           Object.values(filters).some(value => value && value !== '');
//         setIsFiltered(hasActiveFilters);
//       } else {
//         setError('Failed to fetch admin expenses.');
//       }
//     } catch (err) {
//       console.error('Error fetching expenses:', err);
//       setError('Failed to fetch expenses. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCreateExpense = async () => {
//     try {
//       if (!formData.title || !formData.category || !formData.amount) {
//         alert('Please fill all required fields');
//         return;
//       }

//       const expenseData = {
//         ...formData,
//         amount: parseFloat(formData.amount),
//         taxAmount: parseFloat(formData.taxAmount) || 0,
//         discountAmount: parseFloat(formData.discountAmount) || 0
//       };

//       const response = await createAdminExpense(expenseData, token);
//       if (response && response.success) {
//         alert('Expense created successfully');
//         setShowAddModal(false);
//         resetForm();
//         fetchExpenses();
//       }
//     } catch (error) {
//       console.error('Error creating expense:', error);
//       alert('Error creating expense: ' + (error.response?.data?.message || error.message));
//     }
//   };

//   const handleUpdateExpense = async () => {
//     try {
//       const response = await updateAdminExpense(editingExpense._id, formData, token);
//       if (response && response.success) {
//         alert('Expense updated successfully');
//         setEditingExpense(null);
//         resetForm();
//         fetchExpenses();
//       }
//     } catch (error) {
//       console.error('Error updating expense:', error);
//       alert('Error updating expense');
//     }
//   };

//   const handleDeleteExpense = async (id) => {
//     if (window.confirm('Are you sure you want to delete this expense?')) {
//       try {
//         const response = await deleteAdminExpense(id, token);
//         if (response && response.success) {
//           alert('Expense deleted successfully');
//           fetchExpenses();
//         }
//       } catch (error) {
//         console.error('Error deleting expense:', error);
//         alert('Error deleting expense');
//       }
//     }
//   };

//   const handleApproveExpense = async (id, approved) => {
//     try {
//       const response = await approveAdminExpense(id, { approved }, token);
//       if (response && response.success) {
//         alert(`Expense ${approved ? 'approved' : 'rejected'} successfully`);
//         fetchExpenses();
//       }
//     } catch (error) {
//       console.error('Error approving expense:', error);
//       alert('Error processing request');
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       title: '',
//       description: '',
//       category: '',
//       department: 'admin',
//       amount: '',
//       taxAmount: '',
//       discountAmount: '',
//       paymentMethod: 'bank_transfer',
//       paymentStatus: 'pending',
//       expenseDate: new Date().toISOString().split('T')[0],
//       vendorName: '',
//       vendorPhone: '',
//       vendorEmail: '',

//       priority: 'medium',
//       notes: ''
//     });
//   };

//   const handleEditClick = (expense) => {
//     setEditingExpense(expense);
//     setFormData({
//       title: expense.title || '',
//       description: expense.description || '',
//       category: expense.category || '',
//       department: expense.department || 'admin',
//       amount: expense.amount || '',
//       taxAmount: expense.taxAmount || '',
//       discountAmount: expense.discountAmount || '',
//       paymentMethod: expense.paymentMethod || 'bank_transfer',
//       paymentStatus: expense.paymentStatus || 'pending',
//       expenseDate: expense.expenseDate ? new Date(expense.expenseDate).toISOString().split('T')[0] : '',
//       vendorName: expense.vendorName || '',
//       vendorPhone: expense.vendorPhone || '',
//       vendorEmail: expense.vendorEmail || '',

//       priority: expense.priority || 'medium',
//       notes: expense.notes || ''
//     });
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({ ...prev, [name]: value }));
//   };

//   const applyFilters = () => {
//     setCurrentPage(1);
//     fetchExpenses();
//     setShowFilters(false);
//   };

//   const clearFilters = () => {
//     setFilters({
//       startDate: '',
//       endDate: '',
//       category: '',
//       department: '',
//       paymentStatus: '',
//       approvalStatus: '',
//       priority: '',
//       minAmount: '',
//       maxAmount: '',
//       vendorName: ''
//     });
//     setSearchTerm('');
//     setCurrentPage(1);
//     setIsFiltered(false);
//     setTimeout(() => fetchExpenses(), 0);
//   };

//   const handleSort = (field) => {
//     if (sortBy === field) {
//       setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
//     } else {
//       setSortBy(field);
//       setSortOrder('desc');
//     }
//     setCurrentPage(1);
//   };

//   const handleExportReport = () => {
//     if (expenses.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = [
//       'Expense No', 'Title', 'Category', 'Department', 'Amount (₹)',
//       'Net Amount (₹)', 'Vendor', 'Payment Status', 'Approval Status',
//       'Date', 'Priority', 'Invoice No'
//     ];

//     const csvData = expenses.map(expense => [
//       expense.expenseNumber || '',
//       expense.title || '',
//       getCategoryLabel(expense.category),
//       getDepartmentLabel(expense.department),
//       expense.amount || 0,
//       expense.netAmount || 0,
//       expense.vendorName || '',
//       expense.paymentStatus || '',
//       expense.approvalStatus || '',
//       expense.expenseDate ? new Date(expense.expenseDate).toLocaleDateString() : '',
//       expense.priority || '',
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `admin-expenses-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);
//   };

//   const getCategoryLabel = (value) => {
//     const category = categories.find(c => c.value === value);
//     return category ? category.label : value;
//   };

//   const getCategoryIcon = (value) => {
//     const category = categories.find(c => c.value === value);
//     return category ? category.icon : '📦';
//   };

//   const getDepartmentLabel = (value) => {
//     const dept = departments.find(d => d.value === value);
//     return dept ? dept.label : value;
//   };

//   const getStatusBadgeClass = (status) => {
//     const classes = {
//       paid: 'status-paid',
//       pending: 'status-pending',
//       partial: 'status-partial',
//       approved: 'status-approved',
//       rejected: 'status-rejected',
//       on_hold: 'status-hold'
//     };
//     return classes[status] || 'status-default';
//   };

//   const getPriorityClass = (priority) => {
//     const classes = {
//       low: 'priority-low',
//       medium: 'priority-medium',
//       high: 'priority-high',
//       urgent: 'priority-urgent'
//     };
//     return classes[priority] || 'priority-medium';
//   };

//   const formatCurrency = (amount) => {
//     if (amount === undefined || amount === null) return '₹0';
//     return `₹${Number(amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
//   };

//   const generatePageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 5;

//     if (totalPages <= maxVisiblePages) {
//       for (let i = 1; i <= totalPages; i++) pages.push(i);
//     } else {
//       let start = Math.max(1, currentPage - 2);
//       let end = Math.min(totalPages, start + maxVisiblePages - 1);
//       if (end - start + 1 < maxVisiblePages) start = Math.max(1, end - maxVisiblePages + 1);
//       for (let i = start; i <= end; i++) pages.push(i);
//     }
//     return pages;
//   };

//   if (loading && expenses.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="loading-container">
//           <div className="spinner"></div>
//           <p>Loading admin expenses...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Admin Expenses Report</h1>
//         <div className="header-actions">
//           <form onSubmit={(e) => { e.preventDefault(); fetchExpenses(); }} className="search-form">
//             <div style={{ display: 'flex', gap: '8px' }}>
//               <input
//                 type="text"
//                 placeholder="Search by title, vendor, expense no..."
//                 className="search-input"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 style={{ width: "300px" }}
//               />
//               <button type="submit" className="search-btn">Search</button>
//             </div>
//           </form>

//           <button className="add-btn" onClick={() => setShowAddModal(true)}>+ Add Expense</button>
//           {/* <button className="filter-toggle-btn" onClick={() => setShowFilters(!showFilters)}>
//             {showFilters ? 'Hide Filters' : 'Show Filters'}
//           </button> */}
//           <button className="export-btn" onClick={handleExportReport}>Export Report</button>
//         </div>
//       </div>

//       {/* Filter Panel */}
//       {showFilters && (
//         <div className="filter-panel">
//           <div className="filter-header">
//             <h3>Filter Admin Expenses</h3>
//             <button className="close-filters" onClick={() => setShowFilters(false)}>×</button>
//           </div>
//           <div className="filter-grid">
//             <div className="filter-group">
//               <label>Date From</label>
//               <input type="date" name="startDate" value={filters.startDate} onChange={handleFilterChange} />
//             </div>
//             <div className="filter-group">
//               <label>Date To</label>
//               <input type="date" name="endDate" value={filters.endDate} onChange={handleFilterChange} />
//             </div>
//             <div className="filter-group">
//               <label>Category</label>
//               <select name="category" value={filters.category} onChange={handleFilterChange}>
//                 <option value="">All Categories</option>
//                 {categories.map(cat => (
//                   <option key={cat.value} value={cat.value}>{cat.icon} {cat.label}</option>
//                 ))}
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Department</label>
//               <select name="department" value={filters.department} onChange={handleFilterChange}>
//                 <option value="">All Departments</option>
//                 {departments.map(dept => (
//                   <option key={dept.value} value={dept.value}>{dept.icon} {dept.label}</option>
//                 ))}
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Payment Status</label>
//               <select name="paymentStatus" value={filters.paymentStatus} onChange={handleFilterChange}>
//                 <option value="">All</option>
//                 <option value="paid">Paid</option>
//                 <option value="pending">Pending</option>
//                 <option value="partial">Partial</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Approval Status</label>
//               <select name="approvalStatus" value={filters.approvalStatus} onChange={handleFilterChange}>
//                 <option value="">All</option>
//                 <option value="approved">Approved</option>
//                 <option value="pending">Pending</option>
//                 <option value="rejected">Rejected</option>
//                 <option value="on_hold">On Hold</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Priority</label>
//               <select name="priority" value={filters.priority} onChange={handleFilterChange}>
//                 <option value="">All</option>
//                 <option value="low">Low</option>
//                 <option value="medium">Medium</option>
//                 <option value="high">High</option>
//                 <option value="urgent">Urgent</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Min Amount (₹)</label>
//               <input type="number" name="minAmount" value={filters.minAmount} onChange={handleFilterChange} placeholder="Min" />
//             </div>
//             <div className="filter-group">
//               <label>Max Amount (₹)</label>
//               <input type="number" name="maxAmount" value={filters.maxAmount} onChange={handleFilterChange} placeholder="Max" />
//             </div>
//           </div>
//           <div className="filter-actions">
//             <button className="apply-filters-btn" onClick={applyFilters}>Apply Filters</button>
//             <button className="clear-filters-btn" onClick={clearFilters}>Clear All</button>
//           </div>
//         </div>
//       )}

//       {error && <div className="error-message">{error}</div>}

//       {/* Summary Stats Cards */}
//       {summary && (
//         <div className="stats-cards">
//           <div className="stat-card">
//             <h3>Total Expenses</h3>
//             <p>{formatCurrency(summary.totalAmount)}</p>
//             <span>{summary.count} transactions</span>
//           </div>
//           <div className="stat-card">
//             <h3>Paid Amount</h3>
//             <p className="paid">{formatCurrency(summary.paidAmount)}</p>
//             <span>Completed payments</span>
//           </div>
//           <div className="stat-card">
//             <h3>Pending Amount</h3>
//             <p className="pending">{formatCurrency(summary.pendingAmount)}</p>
//             <span>Awaiting payment</span>
//           </div>
//           <div className="stat-card">
//             <h3>Total Tax</h3>
//             <p>{formatCurrency(summary.totalTax)}</p>
//             <span>GST included</span>
//           </div>
//         </div>
//       )}

//       {/* Expenses Table */}
//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th onClick={() => handleSort('expenseNumber')}>Expense No {sortBy === 'expenseNumber' && (sortOrder === 'asc' ? '↑' : '↓')}</th>
//               <th onClick={() => handleSort('title')}>Title</th>
//               <th>Category</th>
//               <th>Department</th>
//               <th onClick={() => handleSort('netAmount')}>Amount</th>
//               {/* <th>Payment Status</th> */}
//               <th>Approval</th>
//               <th>Priority</th>
//               <th>Date</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {expenses.length > 0 ? (
//               expenses.map(expense => (
//                 <tr key={expense._id}>
//                   <td className="expense-number">{expense.expenseNumber}</td>
//                   <td>{expense.title}</td>
//                   <td>
//                     <span className="category-badge">
//                       {getCategoryIcon(expense.category)} {getCategoryLabel(expense.category)}
//                     </span>
//                   </td>
//                   <td>{getDepartmentLabel(expense.department)}</td>
//                   <td className="amount">{formatCurrency(expense.netAmount)}</td>
//                   {/* <td>
//                     <span className={`status-badge ${getStatusBadgeClass(expense.paymentStatus)}`}>
//                       {expense.paymentStatus}
//                     </span>
//                   </td> */}
//                   <td>
//                     <span className={`status-badge ${getStatusBadgeClass(expense.approvalStatus)}`}>
//                       {expense.approvalStatus}
//                     </span>
//                   </td>
//                   <td>
//                     <span className={`priority-badge ${getPriorityClass(expense.priority)}`}>
//                       {expense.priority}
//                     </span>
//                   </td>
//                   <td>{new Date(expense.expenseDate).toLocaleDateString()}</td>
//                   <td>
//                     <div className="action-buttons">
//                       <button className="action-btn view" onClick={() => setViewingExpense(expense)}>View</button>
//                       <button className="action-btn edit" onClick={() => handleEditClick(expense)}>Edit</button>
//                       {expense.approvalStatus === 'pending' && (
//                         <>
//                           <button className="action-btn approve" onClick={() => handleApproveExpense(expense._id, true)}>Approve</button>
//                           <button className="action-btn reject" onClick={() => handleApproveExpense(expense._id, false)}>Reject</button>
//                         </>
//                       )}
//                       <button className="action-btn delete" onClick={() => handleDeleteExpense(expense._id)}>Delete</button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="10" className="no-data">
//                   <p>No admin expenses found {isFiltered ? 'matching your filters' : ''}.</p>
//                   {isFiltered && <button className="clear-filters-link" onClick={clearFilters}>Clear filters</button>}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="pagination-container">
//           <div className="pagination-info">
//             Showing {expenses.length} of {totalItems} expenses (Page {currentPage} of {totalPages})
//           </div>
//           <div className="pagination-controls">
//             <button className="pagination-btn" onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1}>
//               Previous
//             </button>
//             <div className="page-numbers">
//               {generatePageNumbers().map(page => (
//                 <button key={page} className={`page-number ${page === currentPage ? 'active' : ''}`} onClick={() => setCurrentPage(page)}>
//                   {page}
//                 </button>
//               ))}
//             </div>
//             <button className="pagination-btn" onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages}>
//               Next
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Add/Edit Modal */}
//       {(showAddModal || editingExpense) && (
//         <div className="modal-overlay" onClick={() => { setShowAddModal(false); setEditingExpense(null); resetForm(); }}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px', maxHeight: '80vh', overflowY: 'auto' }}>
//             <div className="modal-header">
//               <h3>{editingExpense ? 'Edit Admin Expense' : 'Add New Admin Expense'}</h3>
//               <button className="modal-close-btn" onClick={() => { setShowAddModal(false); setEditingExpense(null); resetForm(); }}>×</button>
//             </div>
//             <div className="modal-body">
//               <div className="form-group">
//                 <label>Title *</label>
//                 <input type="text" value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })} placeholder="Enter expense title" />
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Category *</label>
//                   <select value={formData.category} onChange={(e) => setFormData({ ...formData, category: e.target.value })}>
//                     <option value="">Select Category</option>
//                     {categories.map(cat => (
//                       <option key={cat.value} value={cat.value}>{cat.icon} {cat.label}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Department</label>
//                   <select value={formData.department} onChange={(e) => setFormData({ ...formData, department: e.target.value })}>
//                     {departments.map(dept => (
//                       <option key={dept.value} value={dept.value}>{dept.icon} {dept.label}</option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Amount (₹) *</label>
//                   <input type="number" value={formData.amount} onChange={(e) => setFormData({ ...formData, amount: e.target.value })} placeholder="0" />
//                 </div>
//                 <div className="form-group">
//                   <label>Tax (₹)</label>
//                   <input type="number" value={formData.taxAmount} onChange={(e) => setFormData({ ...formData, taxAmount: e.target.value })} placeholder="0" />
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Payment Method</label>
//                   <select value={formData.paymentMethod} onChange={(e) => setFormData({ ...formData, paymentMethod: e.target.value })}>
//                     <option value="cash">Cash</option>
//                     <option value="bank_transfer">Bank Transfer</option>
//                     <option value="cheque">Cheque</option>
//                     <option value="upi">UPI</option>
//                     <option value="card">Card</option>
//                   </select>
//                 </div>
                
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Expense Date</label>
//                   <input type="date" value={formData.expenseDate} onChange={(e) => setFormData({ ...formData, expenseDate: e.target.value })} />
//                 </div>
//                 <div className="form-group">
//                   <label>Priority</label>
//                   <select value={formData.priority} onChange={(e) => setFormData({ ...formData, priority: e.target.value })}>
//                     <option value="low">Low</option>
//                     <option value="medium">Medium</option>
//                     <option value="high">High</option>
//                     <option value="urgent">Urgent</option>
//                   </select>
//                 </div>
//               </div>
//               <div className="form-group">
//                 <label>Vendor Name</label>
//                 <input type="text" value={formData.vendorName} onChange={(e) => setFormData({ ...formData, vendorName: e.target.value })} placeholder="Vendor/Recipient" />
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Vendor Phone</label>
//                   <input type="tel" value={formData.vendorPhone} onChange={(e) => setFormData({ ...formData, vendorPhone: e.target.value })} placeholder="Phone" />
//                 </div>

//               </div>
//               <div className="form-group">
//                 <label>Description</label>
//                 <textarea value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} rows="3" placeholder="Additional details..."></textarea>
//               </div>
//               <div className="form-group">
//                 <label>Notes</label>
//                 <textarea value={formData.notes} onChange={(e) => setFormData({ ...formData, notes: e.target.value })} rows="2" placeholder="Any notes..."></textarea>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={() => { setShowAddModal(false); setEditingExpense(null); resetForm(); }}>Cancel</button>
//               <button className="action-btn process" onClick={editingExpense ? handleUpdateExpense : handleCreateExpense}>
//                 {editingExpense ? 'Update Expense' : 'Create Expense'}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* View Modal */}
//       {viewingExpense && (
//         <div className="modal-overlay" onClick={() => setViewingExpense(null)}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '700px' }}>
//             <div className="modal-header">
//               <h3>Admin Expense Details - {viewingExpense.expenseNumber}</h3>
//               <button className="modal-close-btn" onClick={() => setViewingExpense(null)}>×</button>
//             </div>
//             <div className="modal-body">
//               <div className="detail-section">
//                 <h4>Basic Information</h4>
//                 <div className="detail-grid">
//                   <div className="detail-row"><label>Title:</label><span>{viewingExpense.title}</span></div>
//                   <div className="detail-row"><label>Category:</label><span>{getCategoryIcon(viewingExpense.category)} {getCategoryLabel(viewingExpense.category)}</span></div>
//                   <div className="detail-row"><label>Department:</label><span>{getDepartmentLabel(viewingExpense.department)}</span></div>
//                   <div className="detail-row"><label>Date:</label><span>{new Date(viewingExpense.expenseDate).toLocaleDateString()}</span></div>
//                   <div className="detail-row"><label>Priority:</label><span className={`priority-badge ${getPriorityClass(viewingExpense.priority)}`}>{viewingExpense.priority}</span></div>
//                 </div>
//               </div>
//               <div className="detail-section">
//                 <h4>Financial Details</h4>
//                 <div className="detail-grid">
//                   <div className="detail-row"><label>Amount:</label><span>{formatCurrency(viewingExpense.amount)}</span></div>
//                   <div className="detail-row"><label>Tax:</label><span>{formatCurrency(viewingExpense.taxAmount)}</span></div>
//                   <div className="detail-row"><label>Net Amount:</label><span className="profit">{formatCurrency(viewingExpense.netAmount)}</span></div>
//                   <div className="detail-row"><label>Payment Method:</label><span>{viewingExpense.paymentMethod}</span></div>
//                   <div className="detail-row"><label>Payment Status:</label><span className={`status-badge ${getStatusBadgeClass(viewingExpense.paymentStatus)}`}>{viewingExpense.paymentStatus}</span></div>
//                 </div>
//               </div>
//               <div className="detail-section">
//                 <h4>Vendor Information</h4>
//                 <div className="detail-grid">
//                   <div className="detail-row"><label>Name:</label><span>{viewingExpense.vendorName || '-'}</span></div>
//                   <div className="detail-row"><label>Phone:</label><span>{viewingExpense.vendorPhone || '-'}</span></div>

//                 </div>
//               </div>
//               <div className="detail-section">
//                 <h4>Approval Information</h4>
//                 <div className="detail-grid">
//                   <div className="detail-row"><label>Requested By:</label><span>{viewingExpense.requestedBy?.name || '-'}</span></div>
//                   <div className="detail-row"><label>Approval Status:</label><span className={`status-badge ${getStatusBadgeClass(viewingExpense.approvalStatus)}`}>{viewingExpense.approvalStatus}</span></div>
//                   {viewingExpense.approvedBy && (
//                     <div className="detail-row"><label>Approved By:</label><span>{viewingExpense.approvedBy?.name || '-'}</span></div>
//                   )}
//                   {viewingExpense.rejectionReason && (
//                     <div className="detail-row"><label>Rejection Reason:</label><span>{viewingExpense.rejectionReason}</span></div>
//                   )}
//                 </div>
//               </div>
//               {viewingExpense.notes && (
//                 <div className="detail-section">
//                   <h4>Notes</h4>
//                   <div className="detail-row"><span>{viewingExpense.notes}</span></div>
//                 </div>
//               )}
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={() => setViewingExpense(null)}>Close</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdminExpensesReport;

// AdminExpensesReport.jsx
// import React, { useState, useEffect, useCallback } from 'react';
// import {
//   getAdminExpenses,
//   getAdminExpenseById,
//   createAdminExpense,
//   updateAdminExpense,
//   deleteAdminExpense,
//   approveAdminExpense,
//   getAdminExpenseCategories,
//   getAdminExpenseDepartments,
//   getAdminExpenseStats
// } from '../../Services/Operations/ProductAPI';
// import '../../Styles/ManagementPages.css';
// import { useSelector } from 'react-redux';

// const AdminExpensesReport = () => {
//   const [expenses, setExpenses] = useState([]);
//   const [summary, setSummary] = useState(null);
//   const [categoryBreakdown, setCategoryBreakdown] = useState([]);
//   const [departmentBreakdown, setDepartmentBreakdown] = useState([]);
//   const [monthlyBreakdown, setMonthlyBreakdown] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewingExpense, setViewingExpense] = useState(null);
//   const [viewingBankDetails, setViewingBankDetails] = useState(null); // New state for bank details modal
//   const [editingExpense, setEditingExpense] = useState(null);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [error, setError] = useState(null);
//   const { token } = useSelector(state => state.user);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalItems, setTotalItems] = useState(0);
//   const [pageSize] = useState(10);

//   // Filter states
//   const [filters, setFilters] = useState({
//     startDate: '',
//     endDate: '',
//     category: '',
//     department: '',
//     paymentStatus: '',
//     approvalStatus: '',
//     priority: '',
//     minAmount: '',
//     maxAmount: '',
//     vendorName: ''
//   });
//   const [showFilters, setShowFilters] = useState(false);
//   const [isFiltered, setIsFiltered] = useState(false);

//   // Sorting states
//   const [sortBy, setSortBy] = useState('expenseDate');
//   const [sortOrder, setSortOrder] = useState('desc');

//   // Form state
//   const [formData, setFormData] = useState({
//     title: '',
//     description: '',
//     category: '',
//     department: 'admin',
//     amount: '',
//     taxAmount: '',
//     discountAmount: '',
//     paymentMethod: 'bank_transfer',
//     paymentStatus: 'pending',
//     expenseDate: new Date().toISOString().split('T')[0],
//     vendorName: '',
//     vendorPhone: '',
//     vendorEmail: '',
//     priority: 'medium',
//     notes: ''
//   });

//   // Fetch categories and departments on mount
//   useEffect(() => {
//     fetchCategories();
//     fetchDepartments();
//   }, []);

//   // Debounced fetch
//   const debouncedFetch = useCallback(() => {
//     const timeoutId = setTimeout(() => {
//       fetchExpenses();
//     }, 500);
//     return () => clearTimeout(timeoutId);
//   }, [currentPage, searchTerm, filters, sortBy, sortOrder]);

//   useEffect(() => {
//     const cleanup = debouncedFetch();
//     return cleanup;
//   }, [debouncedFetch]);

//   const fetchCategories = async () => {
//     try {
//       const response = await getAdminExpenseCategories(token);
//       if (response && response.success) {
//         setCategories(response.data);
//       }
//     } catch (error) {
//       console.error('Error fetching categories:', error);
//     }
//   };

//   const fetchDepartments = async () => {
//     try {
//       const response = await getAdminExpenseDepartments(token);
//       if (response && response.success) {
//         setDepartments(response.data);
//       }
//     } catch (error) {
//       console.error('Error fetching departments:', error);
//     }
//   };

//   const fetchExpenses = async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       const filterParams = {};

//       if (searchTerm && searchTerm.trim()) {
//         filterParams.search = searchTerm.trim();
//       }

//       Object.keys(filters).forEach(key => {
//         if (filters[key] && filters[key] !== '') {
//           filterParams[key] = filters[key];
//         }
//       });

//       const params = {
//         page: currentPage,
//         limit: pageSize,
//         sortBy: sortBy,
//         sortOrder: sortOrder,
//         ...filterParams
//       };

//       const response = await getAdminExpenses(params, token);
// console.log("response getAdminExpenses : ",response)
//       if (response && response.success) {
//         setExpenses(response.data.expenses || []);
//         setSummary(response.data.summary);
//         setCategoryBreakdown(response.data.categoryBreakdown || []);
//         setDepartmentBreakdown(response.data.departmentBreakdown || []);
//         setMonthlyBreakdown(response.data.monthlyBreakdown || []);
//         setTotalPages(response.data.pagination?.totalPages || 1);
//         setTotalItems(response.data.pagination?.totalItems || 0);

//         const hasActiveFilters =
//           (searchTerm && searchTerm.trim() !== '') ||
//           Object.values(filters).some(value => value && value !== '');
//         setIsFiltered(hasActiveFilters);
//       } else {
//         setError('Failed to fetch admin expenses.');
//       }
//     } catch (err) {
//       console.error('Error fetching expenses:', err);
//       setError('Failed to fetch expenses. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCreateExpense = async () => {
//     try {
//       if (!formData.title || !formData.category || !formData.amount) {
//         alert('Please fill all required fields');
//         return;
//       }

//       const expenseData = {
//         ...formData,
//         amount: parseFloat(formData.amount),
//         taxAmount: parseFloat(formData.taxAmount) || 0,
//         discountAmount: parseFloat(formData.discountAmount) || 0
//       };

//       const response = await createAdminExpense(expenseData, token);
//       console.log("response createAdminExpense : ",response)
//       if (response && response.success) {
//         alert('Expense created successfully');
//         setShowAddModal(false);
//         resetForm();
//         fetchExpenses();
//       }
//     } catch (error) {
//       console.error('Error creating expense:', error);
//       alert('Error creating expense: ' + (error.response?.data?.message || error.message));
//     }
//   };

//   const handleUpdateExpense = async () => {
//     try {
//       const response = await updateAdminExpense(editingExpense._id, formData, token);
//       if (response && response.success) {
//         alert('Expense updated successfully');
//         setEditingExpense(null);
//         resetForm();
//         fetchExpenses();
//       }
//     } catch (error) {
//       console.error('Error updating expense:', error);
//       alert('Error updating expense');
//     }
//   };

//   const handleDeleteExpense = async (id) => {
//     if (window.confirm('Are you sure you want to delete this expense?')) {
//       try {
//         const response = await deleteAdminExpense(id, token);
//         if (response && response.success) {
//           alert('Expense deleted successfully');
//           fetchExpenses();
//         }
//       } catch (error) {
//         console.error('Error deleting expense:', error);
//         alert('Error deleting expense');
//       }
//     }
//   };

//   const handleApproveExpense = async (id, approved) => {
//     try {
//       const response = await approveAdminExpense(id, { approved }, token);
//       if (response && response.success) {
//         alert(`Expense ${approved ? 'approved' : 'rejected'} successfully`);
//         fetchExpenses();
//       }
//     } catch (error) {
//       console.error('Error approving expense:', error);
//       alert('Error processing request');
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       title: '',
//       description: '',
//       category: '',
//       department: 'admin',
//       amount: '',
//       taxAmount: '',
//       discountAmount: '',
//       paymentMethod: 'bank_transfer',
//       paymentStatus: 'pending',
//       expenseDate: new Date().toISOString().split('T')[0],
//       vendorName: '',
//       vendorPhone: '',
//       vendorEmail: '',
//       priority: 'medium',
//       notes: ''
//     });
//   };

//   const handleEditClick = (expense) => {
//     setEditingExpense(expense);
//     setFormData({
//       title: expense.title || '',
//       description: expense.description || '',
//       category: expense.category || '',
//       department: expense.department || 'admin',
//       amount: expense.amount || '',
//       taxAmount: expense.taxAmount || '',
//       discountAmount: expense.discountAmount || '',
//       paymentMethod: expense.paymentMethod || 'bank_transfer',
//       paymentStatus: expense.paymentStatus || 'pending',
//       expenseDate: expense.expenseDate ? new Date(expense.expenseDate).toISOString().split('T')[0] : '',
//       vendorName: expense.vendorName || '',
//       vendorPhone: expense.vendorPhone || '',
//       vendorEmail: expense.vendorEmail || '',
//       priority: expense.priority || 'medium',
//       notes: expense.notes || ''
//     });
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({ ...prev, [name]: value }));
//   };

//   const applyFilters = () => {
//     setCurrentPage(1);
//     fetchExpenses();
//     setShowFilters(false);
//   };

//   const clearFilters = () => {
//     setFilters({
//       startDate: '',
//       endDate: '',
//       category: '',
//       department: '',
//       paymentStatus: '',
//       approvalStatus: '',
//       priority: '',
//       minAmount: '',
//       maxAmount: '',
//       vendorName: ''
//     });
//     setSearchTerm('');
//     setCurrentPage(1);
//     setIsFiltered(false);
//     setTimeout(() => fetchExpenses(), 0);
//   };

//   const handleSort = (field) => {
//     if (sortBy === field) {
//       setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
//     } else {
//       setSortBy(field);
//       setSortOrder('desc');
//     }
//     setCurrentPage(1);
//   };

//   const handleExportReport = () => {
//     if (expenses.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = [
//       'Expense No', 'Title', 'Category', 'Department', 'Amount (₹)',
//       'Net Amount (₹)', 'Vendor', 'Payment Status', 'Approval Status',
//       'Date', 'Priority', 'Invoice No'
//     ];

//     const csvData = expenses.map(expense => [
//       expense.expenseNumber || '',
//       expense.title || '',
//       getCategoryLabel(expense.category),
//       getDepartmentLabel(expense.department),
//       expense.amount || 0,
//       expense.netAmount || 0,
//       expense.vendorName || '',
//       expense.paymentStatus || '',
//       expense.approvalStatus || '',
//       expense.expenseDate ? new Date(expense.expenseDate).toLocaleDateString() : '',
//       expense.priority || '',
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `admin-expenses-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);
//   };

//   const getCategoryLabel = (value) => {
//     const category = categories.find(c => c.value === value);
//     return category ? category.label : value;
//   };

//   const getCategoryIcon = (value) => {
//     const category = categories.find(c => c.value === value);
//     return category ? category.icon : '📦';
//   };

//   const getDepartmentLabel = (value) => {
//     const dept = departments.find(d => d.value === value);
//     return dept ? dept.label : value;
//   };

//   const getStatusBadgeClass = (status) => {
//     const classes = {
//       paid: 'status-paid',
//       pending: 'status-pending',
//       partial: 'status-partial',
//       approved: 'status-approved',
//       rejected: 'status-rejected',
//       on_hold: 'status-hold'
//     };
//     return classes[status] || 'status-default';
//   };

//   const getPriorityClass = (priority) => {
//     const classes = {
//       low: 'priority-low',
//       medium: 'priority-medium',
//       high: 'priority-high',
//       urgent: 'priority-urgent'
//     };
//     return classes[priority] || 'priority-medium';
//   };

//   const formatCurrency = (amount) => {
//     if (amount === undefined || amount === null) return '₹0';
//     return `₹${Number(amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
//   };

//   const generatePageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 5;

//     if (totalPages <= maxVisiblePages) {
//       for (let i = 1; i <= totalPages; i++) pages.push(i);
//     } else {
//       let start = Math.max(1, currentPage - 2);
//       let end = Math.min(totalPages, start + maxVisiblePages - 1);
//       if (end - start + 1 < maxVisiblePages) start = Math.max(1, end - maxVisiblePages + 1);
//       for (let i = start; i <= end; i++) pages.push(i);
//     }
//     return pages;
//   };

//   // Function to render bank details section in the view modal
//   const renderBankDetailsSection = () => {
//     if (!viewingExpense || !viewingExpense.bankDetails) return null;

//     const { bankDetails } = viewingExpense;
    
//     return (
//       <div className="detail-section">
//         <h4>Bank Details</h4>
//         <div className="detail-grid">
//           <div className="detail-row">
//             <label>Account Holder Name:</label>
//             <span>{bankDetails.accountHolderName || '-'}</span>
//           </div>
//           <div className="detail-row">
//             <label>Bank Name:</label>
//             <span>{bankDetails.bankName || '-'}</span>
//           </div>
//           <div className="detail-row">
//             <label>Account Number:</label>
//             <span>{bankDetails.accountNumber || '-'}</span>
//           </div>
//           <div className="detail-row">
//             <label>IFSC Code:</label>
//             <span>{bankDetails.ifscCode || '-'}</span>
//           </div>
//           <div className="detail-row">
//             <label>UPI ID:</label>
//             <span>{bankDetails.upiId || '-'}</span>
//           </div>
//           <div className="detail-row">
//             <label>Verification Status:</label>
//             <span className={bankDetails.isVerified ? 'status-approved' : 'status-pending'}>
//               {bankDetails.isVerified ? 'Verified' : 'Pending Verification'}
//             </span>
//           </div>
//           {bankDetails.verifiedAt && (
//             <div className="detail-row">
//               <label>Verified On:</label>
//               <span>{new Date(bankDetails.verifiedAt).toLocaleString()}</span>
//             </div>
//           )}
//         </div>
//       </div>
//     );
//   };

//   // New modal for viewing full bank details
//   const BankDetailsModal = ({ bankDetails, onClose }) => {
//     if (!bankDetails) return null;

//     return (
//       <div className="modal-overlay" onClick={onClose}>
//         <div className="modal-content1" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px' }}>
//           <div className="modal-header">
//             <h3>Bank Details - {bankDetails.accountHolderName || 'Unknown'}</h3>
//             <button className="modal-close-btn" onClick={onClose}>×</button>
//           </div>
//           <div className="modal-body">
//             <div className="detail-section">
//               <div className="detail-grid">
//                 <div className="detail-row">
//                   <label>Account Holder Name:</label>
//                   <span><strong>{bankDetails.accountHolderName || '-'}</strong></span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Bank Name:</label>
//                   <span>{bankDetails.bankName || '-'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Account Number:</label>
//                   <span style={{ fontSize: '16px', fontFamily: 'monospace' }}>{bankDetails.accountNumber || '-'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>IFSC Code:</label>
//                   <span style={{ fontFamily: 'monospace' }}>{bankDetails.ifscCode || '-'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>UPI ID:</label>
//                   <span>{bankDetails.upiId || '-'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Verification Status:</label>
//                   <span>
//                     {bankDetails.isVerified ? (
//                       <span className="status-approved">✓ Verified</span>
//                     ) : (
//                       <span className="status-pending">⚠ Pending Verification</span>
//                     )}
//                   </span>
//                 </div>
//                 {bankDetails.verifiedAt && (
//                   <div className="detail-row">
//                     <label>Verified On:</label>
//                     <span>{new Date(bankDetails.verifiedAt).toLocaleString()}</span>
//                   </div>
//                 )}
//                 {bankDetails.createdAt && (
//                   <div className="detail-row">
//                     <label>Added On:</label>
//                     <span>{new Date(bankDetails.createdAt).toLocaleString()}</span>
//                   </div>
//                 )}
//                 {bankDetails.updatedAt && bankDetails.updatedAt !== bankDetails.createdAt && (
//                   <div className="detail-row">
//                     <label>Last Updated:</label>
//                     <span>{new Date(bankDetails.updatedAt).toLocaleString()}</span>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//           <div className="modal-footer">
//             <button className="modal-close-btn secondary" onClick={onClose}>Close</button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   if (loading && expenses.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="loading-container">
//           <div className="spinner"></div>
//           <p>Loading admin expenses...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Admin Expenses Report</h1>
//         <div className="header-actions">
//           <form onSubmit={(e) => { e.preventDefault(); fetchExpenses(); }} className="search-form">
//             <div style={{ display: 'flex', gap: '8px' }}>
//               <input
//                 type="text"
//                 placeholder="Search by title, vendor, expense no..."
//                 className="search-input"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 style={{ width: "300px" }}
//               />
//               <button type="submit" className="search-btn">Search</button>
//             </div>
//           </form>

//           <button className="add-btn" onClick={() => setShowAddModal(true)}>+ Add Expense</button>
//           <button className="export-btn" onClick={handleExportReport}>Export Report</button>
//         </div>
//       </div>

//       {/* Filter Panel */}
//       {showFilters && (
//         <div className="filter-panel">
//           <div className="filter-header">
//             <h3>Filter Admin Expenses</h3>
//             <button className="close-filters" onClick={() => setShowFilters(false)}>×</button>
//           </div>
//           <div className="filter-grid">
//             <div className="filter-group">
//               <label>Date From</label>
//               <input type="date" name="startDate" value={filters.startDate} onChange={handleFilterChange} />
//             </div>
//             <div className="filter-group">
//               <label>Date To</label>
//               <input type="date" name="endDate" value={filters.endDate} onChange={handleFilterChange} />
//             </div>
//             <div className="filter-group">
//               <label>Category</label>
//               <select name="category" value={filters.category} onChange={handleFilterChange}>
//                 <option value="">All Categories</option>
//                 {categories.map(cat => (
//                   <option key={cat.value} value={cat.value}>{cat.icon} {cat.label}</option>
//                 ))}
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Department</label>
//               <select name="department" value={filters.department} onChange={handleFilterChange}>
//                 <option value="">All Departments</option>
//                 {departments.map(dept => (
//                   <option key={dept.value} value={dept.value}>{dept.icon} {dept.label}</option>
//                 ))}
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Payment Status</label>
//               <select name="paymentStatus" value={filters.paymentStatus} onChange={handleFilterChange}>
//                 <option value="">All</option>
//                 <option value="paid">Paid</option>
//                 <option value="pending">Pending</option>
//                 <option value="partial">Partial</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Approval Status</label>
//               <select name="approvalStatus" value={filters.approvalStatus} onChange={handleFilterChange}>
//                 <option value="">All</option>
//                 <option value="approved">Approved</option>
//                 <option value="pending">Pending</option>
//                 <option value="rejected">Rejected</option>
//                 <option value="on_hold">On Hold</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Priority</label>
//               <select name="priority" value={filters.priority} onChange={handleFilterChange}>
//                 <option value="">All</option>
//                 <option value="low">Low</option>
//                 <option value="medium">Medium</option>
//                 <option value="high">High</option>
//                 <option value="urgent">Urgent</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Min Amount (₹)</label>
//               <input type="number" name="minAmount" value={filters.minAmount} onChange={handleFilterChange} placeholder="Min" />
//             </div>
//             <div className="filter-group">
//               <label>Max Amount (₹)</label>
//               <input type="number" name="maxAmount" value={filters.maxAmount} onChange={handleFilterChange} placeholder="Max" />
//             </div>
//           </div>
//           <div className="filter-actions">
//             <button className="apply-filters-btn" onClick={applyFilters}>Apply Filters</button>
//             <button className="clear-filters-btn" onClick={clearFilters}>Clear All</button>
//           </div>
//         </div>
//       )}

//       {error && <div className="error-message">{error}</div>}

//       {/* Summary Stats Cards */}
//       {summary && (
//         <div className="stats-cards">
//           <div className="stat-card">
//             <h3>Total Expenses</h3>
//             <p>{formatCurrency(summary.totalAmount)}</p>
//             <span>{summary.count} transactions</span>
//           </div>
//           <div className="stat-card">
//             <h3>Paid Amount</h3>
//             <p className="paid">{formatCurrency(summary.paidAmount)}</p>
//             <span>Completed payments</span>
//           </div>
//           <div className="stat-card">
//             <h3>Pending Amount</h3>
//             <p className="pending">{formatCurrency(summary.pendingAmount)}</p>
//             <span>Awaiting payment</span>
//           </div>
//           <div className="stat-card">
//             <h3>Total Tax</h3>
//             <p>{formatCurrency(summary.totalTax)}</p>
//             <span>GST included</span>
//           </div>
//         </div>
//       )}

//       {/* Expenses Table */}
//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th onClick={() => handleSort('expenseNumber')}>Expense No {sortBy === 'expenseNumber' && (sortOrder === 'asc' ? '↑' : '↓')}</th>
//               <th onClick={() => handleSort('title')}>Title</th>
//               <th>Category</th>
//               <th>Department</th>
//               <th onClick={() => handleSort('netAmount')}>Amount</th>
//               <th>Approval</th>
//               <th>Priority</th>
//               <th>Date</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {expenses.length > 0 ? (
//               expenses.map(expense => (
//                 <tr key={expense._id}>
//                   <td className="expense-number">{expense.expenseNumber}</td>
//                   <td>{expense.title}</td>
//                   <td>
//                     <span className="category-badge">
//                       {getCategoryIcon(expense.category)} {getCategoryLabel(expense.category)}
//                     </span>
//                   </td>
//                   <td>{getDepartmentLabel(expense.department)}</td>
//                   <td className="amount">{formatCurrency(expense.netAmount)}</td>
//                   <td>
//                     <span className={`status-badge ${getStatusBadgeClass(expense.approvalStatus)}`}>
//                       {expense.approvalStatus}
//                     </span>
//                   </td>
//                   <td>
//                     <span className={`priority-badge ${getPriorityClass(expense.priority)}`}>
//                       {expense.priority}
//                     </span>
//                   </td>
//                   <td>{new Date(expense.expenseDate).toLocaleDateString()}</td>
//                   <td>
//                     <div className="action-buttons">
//                       <button className="action-btn view" onClick={() => setViewingExpense(expense)}>View</button>
//                       <button className="action-btn edit" onClick={() => handleEditClick(expense)}>Edit</button>
//                       {expense.approvalStatus === 'pending' && (
//                         <>
//                           <button className="action-btn approve" onClick={() => handleApproveExpense(expense._id, true)}>Approve</button>
//                           <button className="action-btn reject" onClick={() => handleApproveExpense(expense._id, false)}>Reject</button>
//                         </>
//                       )}
//                       <button className="action-btn delete" onClick={() => handleDeleteExpense(expense._id)}>Delete</button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="9" className="no-data">
//                   <p>No admin expenses found {isFiltered ? 'matching your filters' : ''}.</p>
//                   {isFiltered && <button className="clear-filters-link" onClick={clearFilters}>Clear filters</button>}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="pagination-container">
//           <div className="pagination-info">
//             Showing {expenses.length} of {totalItems} expenses (Page {currentPage} of {totalPages})
//           </div>
//           <div className="pagination-controls">
//             <button className="pagination-btn" onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1}>
//               Previous
//             </button>
//             <div className="page-numbers">
//               {generatePageNumbers().map(page => (
//                 <button key={page} className={`page-number ${page === currentPage ? 'active' : ''}`} onClick={() => setCurrentPage(page)}>
//                   {page}
//                 </button>
//               ))}
//             </div>
//             <button className="pagination-btn" onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages}>
//               Next
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Add/Edit Modal */}
//       {(showAddModal || editingExpense) && (
//         <div className="modal-overlay" onClick={() => { setShowAddModal(false); setEditingExpense(null); resetForm(); }}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px', maxHeight: '80vh', overflowY: 'auto' }}>
//             <div className="modal-header">
//               <h3>{editingExpense ? 'Edit Admin Expense' : 'Add New Admin Expense'}</h3>
//               <button className="modal-close-btn" onClick={() => { setShowAddModal(false); setEditingExpense(null); resetForm(); }}>×</button>
//             </div>
//             <div className="modal-body">
//               <div className="form-group">
//                 <label>Title *</label>
//                 <input type="text" value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })} placeholder="Enter expense title" />
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Category *</label>
//                   <select value={formData.category} onChange={(e) => setFormData({ ...formData, category: e.target.value })}>
//                     <option value="">Select Category</option>
//                     {categories.map(cat => (
//                       <option key={cat.value} value={cat.value}>{cat.icon} {cat.label}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Department</label>
//                   <select value={formData.department} onChange={(e) => setFormData({ ...formData, department: e.target.value })}>
//                     {departments.map(dept => (
//                       <option key={dept.value} value={dept.value}>{dept.icon} {dept.label}</option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Amount (₹) *</label>
//                   <input type="number" value={formData.amount} onChange={(e) => setFormData({ ...formData, amount: e.target.value })} placeholder="0" />
//                 </div>
//                 <div className="form-group">
//                   <label>Tax (₹)</label>
//                   <input type="number" value={formData.taxAmount} onChange={(e) => setFormData({ ...formData, taxAmount: e.target.value })} placeholder="0" />
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Payment Method</label>
//                   <select value={formData.paymentMethod} onChange={(e) => setFormData({ ...formData, paymentMethod: e.target.value })}>
//                     <option value="cash">Cash</option>
//                     <option value="bank_transfer">Bank Transfer</option>
//                     <option value="cheque">Cheque</option>
//                     <option value="upi">UPI</option>
//                     <option value="card">Card</option>
//                   </select>
//                 </div>
                
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Expense Date</label>
//                   <input type="date" value={formData.expenseDate} onChange={(e) => setFormData({ ...formData, expenseDate: e.target.value })} />
//                 </div>
//                 <div className="form-group">
//                   <label>Priority</label>
//                   <select value={formData.priority} onChange={(e) => setFormData({ ...formData, priority: e.target.value })}>
//                     <option value="low">Low</option>
//                     <option value="medium">Medium</option>
//                     <option value="high">High</option>
//                     <option value="urgent">Urgent</option>
//                   </select>
//                 </div>
//               </div>
//               <div className="form-group">
//                 <label>Vendor Name</label>
//                 <input type="text" value={formData.vendorName} onChange={(e) => setFormData({ ...formData, vendorName: e.target.value })} placeholder="Vendor/Recipient" />
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Vendor Phone</label>
//                   <input type="tel" value={formData.vendorPhone} onChange={(e) => setFormData({ ...formData, vendorPhone: e.target.value })} placeholder="Phone" />
//                 </div>

//               </div>
//               <div className="form-group">
//                 <label>Description</label>
//                 <textarea value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} rows="3" placeholder="Additional details..."></textarea>
//               </div>
//               <div className="form-group">
//                 <label>Notes</label>
//                 <textarea value={formData.notes} onChange={(e) => setFormData({ ...formData, notes: e.target.value })} rows="2" placeholder="Any notes..."></textarea>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={() => { setShowAddModal(false); setEditingExpense(null); resetForm(); }}>Cancel</button>
//               <button className="action-btn process" onClick={editingExpense ? handleUpdateExpense : handleCreateExpense}>
//                 {editingExpense ? 'Update Expense' : 'Create Expense'}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* View Modal - Updated with Bank Details */}
//       {viewingExpense && (
//         <div className="modal-overlay" onClick={() => setViewingExpense(null)}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '700px', maxHeight: '80vh', overflowY: 'auto' }}>
//             <div className="modal-header">
//               <h3>Admin Expense Details - {viewingExpense.expenseNumber}</h3>
//               <button className="modal-close-btn" onClick={() => setViewingExpense(null)}>×</button>
//             </div>
//             <div className="modal-body">
//               <div className="detail-section">
//                 <h4>Basic Information</h4>
//                 <div className="detail-grid">
//                   <div className="detail-row"><label>Title:</label><span>{viewingExpense.title}</span></div>
//                   <div className="detail-row"><label>Category:</label><span>{getCategoryIcon(viewingExpense.category)} {getCategoryLabel(viewingExpense.category)}</span></div>
//                   <div className="detail-row"><label>Department:</label><span>{getDepartmentLabel(viewingExpense.department)}</span></div>
//                   <div className="detail-row"><label>Date:</label><span>{new Date(viewingExpense.expenseDate).toLocaleDateString()}</span></div>
//                   <div className="detail-row"><label>Priority:</label><span className={`priority-badge ${getPriorityClass(viewingExpense.priority)}`}>{viewingExpense.priority}</span></div>
//                 </div>
//               </div>
//               <div className="detail-section">
//                 <h4>Financial Details</h4>
//                 <div className="detail-grid">
//                   <div className="detail-row"><label>Amount:</label><span>{formatCurrency(viewingExpense.amount)}</span></div>
//                   <div className="detail-row"><label>Tax:</label><span>{formatCurrency(viewingExpense.taxAmount)}</span></div>
//                   <div className="detail-row"><label>Net Amount:</label><span className="profit">{formatCurrency(viewingExpense.netAmount)}</span></div>
//                   <div className="detail-row"><label>Payment Method:</label><span>{viewingExpense.paymentMethod}</span></div>
//                   <div className="detail-row"><label>Payment Status:</label><span className={`status-badge ${getStatusBadgeClass(viewingExpense.paymentStatus)}`}>{viewingExpense.paymentStatus}</span></div>
//                 </div>
//               </div>
//               <div className="detail-section">
//                 <h4>Vendor Information</h4>
//                 <div className="detail-grid">
//                   <div className="detail-row"><label>Name:</label><span>{viewingExpense.vendorName || '-'}</span></div>
//                   <div className="detail-row"><label>Phone:</label><span>{viewingExpense.vendorPhone || '-'}</span></div>
//                 </div>
//               </div>
              
//               {/* Render Bank Details Section */}
//               {renderBankDetailsSection()}
              
//               <div className="detail-section">
//                 <h4>Approval Information</h4>
//                 <div className="detail-grid">
//                   <div className="detail-row"><label>Requested By:</label><span>{viewingExpense.requestedBy?.name || '-'}</span></div>
//                   <div className="detail-row"><label>Approval Status:</label><span className={`status-badge ${getStatusBadgeClass(viewingExpense.approvalStatus)}`}>{viewingExpense.approvalStatus}</span></div>
//                   {viewingExpense.approvedBy && (
//                     <div className="detail-row"><label>Approved By:</label><span>{viewingExpense.approvedBy?.name || '-'}</span></div>
//                   )}
//                   {viewingExpense.rejectionReason && (
//                     <div className="detail-row"><label>Rejection Reason:</label><span>{viewingExpense.rejectionReason}</span></div>
//                   )}
//                 </div>
//               </div>
//               {viewingExpense.notes && (
//                 <div className="detail-section">
//                   <h4>Notes</h4>
//                   <div className="detail-row"><span>{viewingExpense.notes}</span></div>
//                 </div>
//               )}
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={() => setViewingExpense(null)}>Close</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Bank Details Modal */}
//       {viewingBankDetails && (
//         <BankDetailsModal 
//           bankDetails={viewingBankDetails} 
//           onClose={() => setViewingBankDetails(null)} 
//         />
//       )}
//     </div>
//   );
// };

// export default AdminExpensesReport;

import React, { useState, useEffect, useCallback } from 'react';
import {
  getAdminExpenses,
  getAdminExpenseById,
  createAdminExpense,
  updateAdminExpense,
  deleteAdminExpense,
  approveAdminExpense,
  getAdminExpenseCategories,
  getAdminExpenseDepartments,
  getAdminExpenseStats
} from '../../Services/Operations/ProductAPI';
import '../../Styles/ManagementPages.css';
import { useSelector } from 'react-redux';

// Skeleton Components
const SkeletonStatsCard = () => (
  <div className="stat-card skeleton">
    <div className="skeleton-title"></div>
    <div className="skeleton-value"></div>
    <div className="skeleton-subtitle"></div>
  </div>
);

const SkeletonTableRow = () => (
  <tr className="skeleton-row">
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-actions"></div></td>
   </tr>
);

const SkeletonTable = () => (
  <div className="table-container skeleton">
    <table className="data-table">
      <thead>
        <tr>
          <th>Expense No</th>
          <th>Title</th>
          <th>Category</th>
          <th>Department</th>
          <th>Amount</th>
          <th>Approval</th>
          <th>Priority</th>
          <th>Date</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
          <SkeletonTableRow key={i} />
        ))}
      </tbody>
    </table>
  </div>
);

const SkeletonModal = () => (
  <div className="modal-overlay">
    <div className="modal-content1 skeleton-modal" style={{ maxWidth: '700px' }}>
      <div className="modal-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="modal-body">
        <div className="detail-section">
          <div className="skeleton-section-title"></div>
          <div className="detail-grid">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="skeleton-detail-row">
                <div className="skeleton-label"></div>
                <div className="skeleton-value"></div>
              </div>
            ))}
          </div>
        </div>
        <div className="detail-section">
          <div className="skeleton-section-title"></div>
          <div className="detail-grid">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="skeleton-detail-row">
                <div className="skeleton-label"></div>
                <div className="skeleton-value"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const SkeletonFormModal = () => (
  <div className="modal-overlay">
    <div className="modal-content1 skeleton-modal" style={{ maxWidth: '600px' }}>
      <div className="modal-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="modal-body">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
          <div key={i} className="form-group">
            <div className="skeleton-label"></div>
            <div className="skeleton-input"></div>
          </div>
        ))}
      </div>
      <div className="modal-footer">
        <div className="skeleton-button"></div>
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const AdminExpensesReport = () => {
  const [expenses, setExpenses] = useState([]);
  const [summary, setSummary] = useState(null);
  const [categoryBreakdown, setCategoryBreakdown] = useState([]);
  const [departmentBreakdown, setDepartmentBreakdown] = useState([]);
  const [monthlyBreakdown, setMonthlyBreakdown] = useState([]);
  const [categories, setCategories] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searching, setSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [viewingExpense, setViewingExpense] = useState(null);
  const [viewingBankDetails, setViewingBankDetails] = useState(null);
  const [editingExpense, setEditingExpense] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [error, setError] = useState(null);
  const { token } = useSelector(state => state.user);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [pageSize] = useState(10);

  // Filter states
  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
    category: '',
    department: '',
    paymentStatus: '',
    approvalStatus: '',
    priority: '',
    minAmount: '',
    maxAmount: '',
    vendorName: ''
  });
  const [showFilters, setShowFilters] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);

  // Sorting states
  const [sortBy, setSortBy] = useState('expenseDate');
  const [sortOrder, setSortOrder] = useState('desc');

  // Form state
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    category: '',
    department: 'admin',
    amount: '',
    taxAmount: '',
    discountAmount: '',
    paymentMethod: 'bank_transfer',
    paymentStatus: 'pending',
    expenseDate: new Date().toISOString().split('T')[0],
    vendorName: '',
    vendorPhone: '',
    vendorEmail: '',
    priority: 'medium',
    notes: ''
  });

  // Fetch categories and departments on mount
  useEffect(() => {
    fetchCategories();
    fetchDepartments();
  }, []);

  // Debounced fetch
  const debouncedFetch = useCallback(() => {
    const timeoutId = setTimeout(() => {
      fetchExpenses();
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [currentPage, searchTerm, filters, sortBy, sortOrder]);

  useEffect(() => {
    const cleanup = debouncedFetch();
    return cleanup;
  }, [debouncedFetch]);

  const fetchCategories = async () => {
    try {
      const response = await getAdminExpenseCategories(token);
      if (response && response.success) {
        setCategories(response.data);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await getAdminExpenseDepartments(token);
      if (response && response.success) {
        setDepartments(response.data);
      }
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

  const fetchExpenses = async () => {
    try {
      setSearching(true);
      setLoading(true);
      setError(null);

      const filterParams = {};

      if (searchTerm && searchTerm.trim()) {
        filterParams.search = searchTerm.trim();
      }

      Object.keys(filters).forEach(key => {
        if (filters[key] && filters[key] !== '') {
          filterParams[key] = filters[key];
        }
      });

      const params = {
        page: currentPage,
        limit: pageSize,
        sortBy: sortBy,
        sortOrder: sortOrder,
        ...filterParams
      };

      const response = await getAdminExpenses(params, token);
      console.log("response getAdminExpenses : ", response);

      if (response && response.success) {
        setExpenses(response.data.expenses || []);
        setSummary(response.data.summary);
        setCategoryBreakdown(response.data.categoryBreakdown || []);
        setDepartmentBreakdown(response.data.departmentBreakdown || []);
        setMonthlyBreakdown(response.data.monthlyBreakdown || []);
        setTotalPages(response.data.pagination?.totalPages || 1);
        setTotalItems(response.data.pagination?.totalItems || 0);

        const hasActiveFilters =
          (searchTerm && searchTerm.trim() !== '') ||
          Object.values(filters).some(value => value && value !== '');
        setIsFiltered(hasActiveFilters);
      } else {
        setError('Failed to fetch admin expenses.');
      }
    } catch (err) {
      console.error('Error fetching expenses:', err);
      setError('Failed to fetch expenses. Please try again.');
    } finally {
      setLoading(false);
      setSearching(false);
    }
  };

  const handleCreateExpense = async () => {
    try {
      if (!formData.title || !formData.category || !formData.amount) {
        alert('Please fill all required fields');
        return;
      }

      const expenseData = {
        ...formData,
        amount: parseFloat(formData.amount),
        taxAmount: parseFloat(formData.taxAmount) || 0,
        discountAmount: parseFloat(formData.discountAmount) || 0
      };

      const response = await createAdminExpense(expenseData, token);
      console.log("response createAdminExpense : ", response);
      if (response && response.success) {
        alert('Expense created successfully');
        setShowAddModal(false);
        resetForm();
        fetchExpenses();
      }
    } catch (error) {
      console.error('Error creating expense:', error);
      alert('Error creating expense: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleUpdateExpense = async () => {
    try {
      const response = await updateAdminExpense(editingExpense._id, formData, token);
      if (response && response.success) {
        alert('Expense updated successfully');
        setEditingExpense(null);
        resetForm();
        fetchExpenses();
      }
    } catch (error) {
      console.error('Error updating expense:', error);
      alert('Error updating expense');
    }
  };

  const handleDeleteExpense = async (id) => {
    if (window.confirm('Are you sure you want to delete this expense?')) {
      try {
        const response = await deleteAdminExpense(id, token);
        if (response && response.success) {
          alert('Expense deleted successfully');
          fetchExpenses();
        }
      } catch (error) {
        console.error('Error deleting expense:', error);
        alert('Error deleting expense');
      }
    }
  };

  const handleApproveExpense = async (id, approved) => {
    try {
      const response = await approveAdminExpense(id, { approved }, token);
      if (response && response.success) {
        alert(`Expense ${approved ? 'approved' : 'rejected'} successfully`);
        fetchExpenses();
      }
    } catch (error) {
      console.error('Error approving expense:', error);
      alert('Error processing request');
    }
  };

  const resetForm = () => {
    setFormData({
      title: '',
      description: '',
      category: '',
      department: 'admin',
      amount: '',
      taxAmount: '',
      discountAmount: '',
      paymentMethod: 'bank_transfer',
      paymentStatus: 'pending',
      expenseDate: new Date().toISOString().split('T')[0],
      vendorName: '',
      vendorPhone: '',
      vendorEmail: '',
      priority: 'medium',
      notes: ''
    });
  };

  const handleEditClick = (expense) => {
    setEditingExpense(expense);
    setFormData({
      title: expense.title || '',
      description: expense.description || '',
      category: expense.category || '',
      department: expense.department || 'admin',
      amount: expense.amount || '',
      taxAmount: expense.taxAmount || '',
      discountAmount: expense.discountAmount || '',
      paymentMethod: expense.paymentMethod || 'bank_transfer',
      paymentStatus: expense.paymentStatus || 'pending',
      expenseDate: expense.expenseDate ? new Date(expense.expenseDate).toISOString().split('T')[0] : '',
      vendorName: expense.vendorName || '',
      vendorPhone: expense.vendorPhone || '',
      vendorEmail: expense.vendorEmail || '',
      priority: expense.priority || 'medium',
      notes: expense.notes || ''
    });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const applyFilters = () => {
    setCurrentPage(1);
    fetchExpenses();
    setShowFilters(false);
  };

  const clearFilters = () => {
    setFilters({
      startDate: '',
      endDate: '',
      category: '',
      department: '',
      paymentStatus: '',
      approvalStatus: '',
      priority: '',
      minAmount: '',
      maxAmount: '',
      vendorName: ''
    });
    setSearchTerm('');
    setCurrentPage(1);
    setIsFiltered(false);
    setTimeout(() => fetchExpenses(), 0);
  };

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(field);
      setSortOrder('desc');
    }
    setCurrentPage(1);
  };

  const handleExportReport = () => {
    if (expenses.length === 0) {
      alert('No data to export');
      return;
    }

    const headers = [
      'Expense No', 'Title', 'Category', 'Department', 'Amount (₹)',
      'Net Amount (₹)', 'Vendor', 'Payment Status', 'Approval Status',
      'Date', 'Priority', 'Invoice No'
    ];

    const csvData = expenses.map(expense => [
      expense.expenseNumber || '',
      expense.title || '',
      getCategoryLabel(expense.category),
      getDepartmentLabel(expense.department),
      expense.amount || 0,
      expense.netAmount || 0,
      expense.vendorName || '',
      expense.paymentStatus || '',
      expense.approvalStatus || '',
      expense.expenseDate ? new Date(expense.expenseDate).toLocaleDateString() : '',
      expense.priority || '',
    ]);

    const csvContent = [
      headers.join(','),
      ...csvData.map(row => row.map(field => `"${field}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `admin-expenses-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const getCategoryLabel = (value) => {
    const category = categories.find(c => c.value === value);
    return category ? category.label : value;
  };

  const getCategoryIcon = (value) => {
    const category = categories.find(c => c.value === value);
    return category ? category.icon : '📦';
  };

  const getDepartmentLabel = (value) => {
    const dept = departments.find(d => d.value === value);
    return dept ? dept.label : value;
  };

  const getStatusBadgeClass = (status) => {
    const classes = {
      paid: 'status-paid',
      pending: 'status-pending',
      partial: 'status-partial',
      approved: 'status-approved',
      rejected: 'status-rejected',
      on_hold: 'status-hold'
    };
    return classes[status] || 'status-default';
  };

  const getPriorityClass = (priority) => {
    const classes = {
      low: 'priority-low',
      medium: 'priority-medium',
      high: 'priority-high',
      urgent: 'priority-urgent'
    };
    return classes[priority] || 'priority-medium';
  };

  const formatCurrency = (amount) => {
    if (amount === undefined || amount === null) return '₹0';
    return `₹${Number(amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const generatePageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      let start = Math.max(1, currentPage - 2);
      let end = Math.min(totalPages, start + maxVisiblePages - 1);
      if (end - start + 1 < maxVisiblePages) start = Math.max(1, end - maxVisiblePages + 1);
      for (let i = start; i <= end; i++) pages.push(i);
    }
    return pages;
  };

  // Function to render bank details section in the view modal
  const renderBankDetailsSection = () => {
    if (!viewingExpense || !viewingExpense.bankDetails) return null;

    const { bankDetails } = viewingExpense;
    
    return (
      <div className="detail-section">
        <h4>Bank Details</h4>
        <div className="detail-grid">
          <div className="detail-row">
            <label>Account Holder Name:</label>
            <span>{bankDetails.accountHolderName || '-'}</span>
          </div>
          <div className="detail-row">
            <label>Bank Name:</label>
            <span>{bankDetails.bankName || '-'}</span>
          </div>
          <div className="detail-row">
            <label>Account Number:</label>
            <span>{bankDetails.accountNumber || '-'}</span>
          </div>
          <div className="detail-row">
            <label>IFSC Code:</label>
            <span>{bankDetails.ifscCode || '-'}</span>
          </div>
          <div className="detail-row">
            <label>UPI ID:</label>
            <span>{bankDetails.upiId || '-'}</span>
          </div>
          <div className="detail-row">
            <label>Verification Status:</label>
            <span className={bankDetails.isVerified ? 'status-approved' : 'status-pending'}>
              {bankDetails.isVerified ? 'Verified' : 'Pending Verification'}
            </span>
          </div>
          {bankDetails.verifiedAt && (
            <div className="detail-row">
              <label>Verified On:</label>
              <span>{new Date(bankDetails.verifiedAt).toLocaleString()}</span>
            </div>
          )}
        </div>
      </div>
    );
  };

  // New modal for viewing full bank details
  const BankDetailsModal = ({ bankDetails, onClose }) => {
    if (!bankDetails) return null;

    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content1" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px' }}>
          <div className="modal-header">
            <h3>Bank Details - {bankDetails.accountHolderName || 'Unknown'}</h3>
            <button className="modal-close-btn" onClick={onClose}>×</button>
          </div>
          <div className="modal-body">
            <div className="detail-section">
              <div className="detail-grid">
                <div className="detail-row">
                  <label>Account Holder Name:</label>
                  <span><strong>{bankDetails.accountHolderName || '-'}</strong></span>
                </div>
                <div className="detail-row">
                  <label>Bank Name:</label>
                  <span>{bankDetails.bankName || '-'}</span>
                </div>
                <div className="detail-row">
                  <label>Account Number:</label>
                  <span style={{ fontSize: '16px', fontFamily: 'monospace' }}>{bankDetails.accountNumber || '-'}</span>
                </div>
                <div className="detail-row">
                  <label>IFSC Code:</label>
                  <span style={{ fontFamily: 'monospace' }}>{bankDetails.ifscCode || '-'}</span>
                </div>
                <div className="detail-row">
                  <label>UPI ID:</label>
                  <span>{bankDetails.upiId || '-'}</span>
                </div>
                <div className="detail-row">
                  <label>Verification Status:</label>
                  <span>
                    {bankDetails.isVerified ? (
                      <span className="status-approved">✓ Verified</span>
                    ) : (
                      <span className="status-pending">⚠ Pending Verification</span>
                    )}
                  </span>
                </div>
                {bankDetails.verifiedAt && (
                  <div className="detail-row">
                    <label>Verified On:</label>
                    <span>{new Date(bankDetails.verifiedAt).toLocaleString()}</span>
                  </div>
                )}
                {bankDetails.createdAt && (
                  <div className="detail-row">
                    <label>Added On:</label>
                    <span>{new Date(bankDetails.createdAt).toLocaleString()}</span>
                  </div>
                )}
                {bankDetails.updatedAt && bankDetails.updatedAt !== bankDetails.createdAt && (
                  <div className="detail-row">
                    <label>Last Updated:</label>
                    <span>{new Date(bankDetails.updatedAt).toLocaleString()}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="modal-close-btn secondary" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    );
  };

  // Loading state with skeletons
  if (loading && expenses.length === 0) {
    return (
      <div className="management-page">
        <div className="page-header">
          <div className="skeleton-header-title"></div>
          <div className="header-actions">
            <div className="skeleton-search"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>

        <div className="stats-cards">
          {[1, 2, 3, 4].map((i) => (
            <SkeletonStatsCard key={i} />
          ))}
        </div>

        <SkeletonTable />

        <div className="pagination-container">
          <div className="skeleton-pagination-info"></div>
          <div className="skeleton-pagination-controls"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="management-page">
      <div className="page-header">
        <h1>Admin Expenses Report</h1>
        <div className="header-actions">
          <form onSubmit={(e) => { e.preventDefault(); fetchExpenses(); }} className="search-form">
            <div style={{ position: 'relative', display: 'flex', gap: '8px' }}>
              <input
                type="text"
                placeholder="Search by title, vendor, expense no..."
                className="search-input"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ width: "300px" }}
              />
              {searching && (
                <span style={{
                  position: 'absolute', right: '80px', top: '50%',
                  transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
                }}>
                  searching...
                </span>
              )}
              <button type="submit" className="search-btn">Search</button>
            </div>
          </form>

          <button className="filter-toggle-btn" onClick={() => setShowFilters(!showFilters)}>
            {showFilters ? 'Hide Filters' : 'Show Filters'}
          </button>
          <button className="add-btn" onClick={() => setShowAddModal(true)}>+ Add Expense</button>
          <button className="export-btn" onClick={handleExportReport}>Export Report</button>
        </div>
      </div>

      {/* Filter Panel */}
      {showFilters && (
        <div className="filter-panel">
          <div className="filter-header">
            <h3>Filter Admin Expenses</h3>
            <button className="close-filters" onClick={() => setShowFilters(false)}>×</button>
          </div>
          <div className="filter-grid">
            <div className="filter-group">
              <label>Date From</label>
              <input type="date" name="startDate" value={filters.startDate} onChange={handleFilterChange} />
            </div>
            <div className="filter-group">
              <label>Date To</label>
              <input type="date" name="endDate" value={filters.endDate} onChange={handleFilterChange} />
            </div>
            <div className="filter-group">
              <label>Category</label>
              <select name="category" value={filters.category} onChange={handleFilterChange}>
                <option value="">All Categories</option>
                {categories.map(cat => (
                  <option key={cat.value} value={cat.value}>{cat.icon} {cat.label}</option>
                ))}
              </select>
            </div>
            <div className="filter-group">
              <label>Department</label>
              <select name="department" value={filters.department} onChange={handleFilterChange}>
                <option value="">All Departments</option>
                {departments.map(dept => (
                  <option key={dept.value} value={dept.value}>{dept.icon} {dept.label}</option>
                ))}
              </select>
            </div>
            <div className="filter-group">
              <label>Payment Status</label>
              <select name="paymentStatus" value={filters.paymentStatus} onChange={handleFilterChange}>
                <option value="">All</option>
                <option value="paid">Paid</option>
                <option value="pending">Pending</option>
                <option value="partial">Partial</option>
              </select>
            </div>
            <div className="filter-group">
              <label>Approval Status</label>
              <select name="approvalStatus" value={filters.approvalStatus} onChange={handleFilterChange}>
                <option value="">All</option>
                <option value="approved">Approved</option>
                <option value="pending">Pending</option>
                <option value="rejected">Rejected</option>
                <option value="on_hold">On Hold</option>
              </select>
            </div>
            <div className="filter-group">
              <label>Priority</label>
              <select name="priority" value={filters.priority} onChange={handleFilterChange}>
                <option value="">All</option>
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
                <option value="urgent">Urgent</option>
              </select>
            </div>
            <div className="filter-group">
              <label>Min Amount (₹)</label>
              <input type="number" name="minAmount" value={filters.minAmount} onChange={handleFilterChange} placeholder="Min" />
            </div>
            <div className="filter-group">
              <label>Max Amount (₹)</label>
              <input type="number" name="maxAmount" value={filters.maxAmount} onChange={handleFilterChange} placeholder="Max" />
            </div>
          </div>
          <div className="filter-actions">
            <button className="apply-filters-btn" onClick={applyFilters}>Apply Filters</button>
            <button className="clear-filters-btn" onClick={clearFilters}>Clear All</button>
          </div>
          {isFiltered && (
            <div className="active-filters">
              <span>Active Filters:</span>
              {searchTerm && <span className="filter-tag">Search: {searchTerm}</span>}
              {filters.category && <span className="filter-tag">Category: {getCategoryLabel(filters.category)}</span>}
              {filters.department && <span className="filter-tag">Dept: {getDepartmentLabel(filters.department)}</span>}
              {filters.paymentStatus && <span className="filter-tag">Payment: {filters.paymentStatus}</span>}
              {filters.approvalStatus && <span className="filter-tag">Approval: {filters.approvalStatus}</span>}
              {filters.priority && <span className="filter-tag">Priority: {filters.priority}</span>}
              {filters.startDate && <span className="filter-tag">From: {filters.startDate}</span>}
              {filters.endDate && <span className="filter-tag">To: {filters.endDate}</span>}
            </div>
          )}
        </div>
      )}

      {error && <div className="error-message">{error}</div>}

      {/* Summary Stats Cards */}
      {summary && (
        <div className="stats-cards">
          <div className="stat-card">
            <h3>Total Expenses</h3>
            <p>{formatCurrency(summary.totalAmount)}</p>
            <span>{summary.count} transactions</span>
          </div>
          <div className="stat-card">
            <h3>Paid Amount</h3>
            <p className="paid">{formatCurrency(summary.paidAmount)}</p>
            <span>Completed payments</span>
          </div>
          <div className="stat-card">
            <h3>Pending Amount</h3>
            <p className="pending">{formatCurrency(summary.pendingAmount)}</p>
            <span>Awaiting payment</span>
          </div>
          <div className="stat-card">
            <h3>Total Tax</h3>
            <p>{formatCurrency(summary.totalTax)}</p>
            <span>GST included</span>
          </div>
        </div>
      )}

      {/* Loading indicator for table while fetching but not initial load */}
      {loading && expenses.length > 0 && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <span>Updating data...</span>
        </div>
      )}

      {/* Expenses Table */}
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th onClick={() => handleSort('expenseNumber')} style={{ cursor: 'pointer' }}>
                Expense No {sortBy === 'expenseNumber' && (sortOrder === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('title')} style={{ cursor: 'pointer' }}>
                Title {sortBy === 'title' && (sortOrder === 'asc' ? '↑' : '↓')}
              </th>
              <th>Category</th>
              <th>Department</th>
              <th onClick={() => handleSort('netAmount')} style={{ cursor: 'pointer' }}>
                Amount {sortBy === 'netAmount' && (sortOrder === 'asc' ? '↑' : '↓')}
              </th>
              <th>Approval</th>
              <th>Priority</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {expenses.length > 0 ? (
              expenses.map(expense => (
                <tr key={expense._id}>
                  <td className="expense-number">{expense.expenseNumber}</td>
                  <td>{expense.title}</td>
                  <td>
                    <span className="category-badge">
                      {getCategoryIcon(expense.category)} {getCategoryLabel(expense.category)}
                    </span>
                  </td>
                  <td>{getDepartmentLabel(expense.department)}</td>
                  <td className="amount">{formatCurrency(expense.netAmount)}</td>
                  <td>
                    <span className={`status-badge ${getStatusBadgeClass(expense.approvalStatus)}`}>
                      {expense.approvalStatus}
                    </span>
                  </td>
                  <td>
                    <span className={`priority-badge ${getPriorityClass(expense.priority)}`}>
                      {expense.priority}
                    </span>
                  </td>
                  <td>{new Date(expense.expenseDate).toLocaleDateString()}</td>
                  <td>
                    <div className="action-buttons">
                      <button className="action-btn view" onClick={() => setViewingExpense(expense)} disabled={loading}>
                        {loading ? '...' : 'View'}
                      </button>
                      <button className="action-btn edit" onClick={() => handleEditClick(expense)} disabled={loading}>
                        Edit
                      </button>
                      {expense.approvalStatus === 'pending' && (
                        <>
                          <button className="action-btn approve" onClick={() => handleApproveExpense(expense._id, true)} disabled={loading}>
                            Approve
                          </button>
                          <button className="action-btn reject" onClick={() => handleApproveExpense(expense._id, false)} disabled={loading}>
                            Reject
                          </button>
                        </>
                      )}
                      <button className="action-btn delete" onClick={() => handleDeleteExpense(expense._id)} disabled={loading}>
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="no-data">
                  <p>No admin expenses found {isFiltered ? 'matching your filters' : ''}.</p>
                  {isFiltered && <button className="clear-filters-link" onClick={clearFilters}>Clear filters</button>}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="pagination-container">
          <div className="pagination-info">
            Showing {expenses.length} of {totalItems} expenses (Page {currentPage} of {totalPages})
            {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
            {isFiltered && !searchTerm && <span className="filtered-indicator"> • Filtered Results</span>}
          </div>
          <div className="pagination-controls">
            <button 
              className="pagination-btn" 
              onClick={() => setCurrentPage(p => Math.max(1, p - 1))} 
              disabled={currentPage === 1 || loading}
            >
              Previous
            </button>
            <div className="page-numbers">
              {generatePageNumbers().map(page => (
                <button 
                  key={page} 
                  className={`page-number ${page === currentPage ? 'active' : ''}`} 
                  onClick={() => setCurrentPage(page)}
                  disabled={loading}
                >
                  {page}
                </button>
              ))}
            </div>
            <button 
              className="pagination-btn" 
              onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} 
              disabled={currentPage === totalPages || loading}
            >
              Next
            </button>
          </div>
        </div>
      )}

      {/* Add/Edit Modal */}
      {(showAddModal || editingExpense) && !loading && (
        <div className="modal-overlay" onClick={() => { setShowAddModal(false); setEditingExpense(null); resetForm(); }}>
          <div className="modal-content1" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px', maxHeight: '80vh', overflowY: 'auto' }}>
            <div className="modal-header">
              <h3>{editingExpense ? 'Edit Admin Expense' : 'Add New Admin Expense'}</h3>
              <button className="modal-close-btn" onClick={() => { setShowAddModal(false); setEditingExpense(null); resetForm(); }}>×</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Title *</label>
                <input type="text" value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })} placeholder="Enter expense title" />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Category *</label>
                  <select value={formData.category} onChange={(e) => setFormData({ ...formData, category: e.target.value })}>
                    <option value="">Select Category</option>
                    {categories.map(cat => (
                      <option key={cat.value} value={cat.value}>{cat.icon} {cat.label}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Department</label>
                  <select value={formData.department} onChange={(e) => setFormData({ ...formData, department: e.target.value })}>
                    {departments.map(dept => (
                      <option key={dept.value} value={dept.value}>{dept.icon} {dept.label}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Amount (₹) *</label>
                  <input type="number" value={formData.amount} onChange={(e) => setFormData({ ...formData, amount: e.target.value })} placeholder="0" />
                </div>
                <div className="form-group">
                  <label>Tax (₹)</label>
                  <input type="number" value={formData.taxAmount} onChange={(e) => setFormData({ ...formData, taxAmount: e.target.value })} placeholder="0" />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Payment Method</label>
                  <select value={formData.paymentMethod} onChange={(e) => setFormData({ ...formData, paymentMethod: e.target.value })}>
                    <option value="cash">Cash</option>
                    <option value="bank_transfer">Bank Transfer</option>
                    <option value="cheque">Cheque</option>
                    <option value="upi">UPI</option>
                    <option value="card">Card</option>
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Expense Date</label>
                  <input type="date" value={formData.expenseDate} onChange={(e) => setFormData({ ...formData, expenseDate: e.target.value })} />
                </div>
                <div className="form-group">
                  <label>Priority</label>
                  <select value={formData.priority} onChange={(e) => setFormData({ ...formData, priority: e.target.value })}>
                    <option value="low">Low</option>
                    <option value="medium">Medium</option>
                    <option value="high">High</option>
                    <option value="urgent">Urgent</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label>Vendor Name</label>
                <input type="text" value={formData.vendorName} onChange={(e) => setFormData({ ...formData, vendorName: e.target.value })} placeholder="Vendor/Recipient" />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Vendor Phone</label>
                  <input type="tel" value={formData.vendorPhone} onChange={(e) => setFormData({ ...formData, vendorPhone: e.target.value })} placeholder="Phone" />
                </div>
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} rows="3" placeholder="Additional details..."></textarea>
              </div>
              <div className="form-group">
                <label>Notes</label>
                <textarea value={formData.notes} onChange={(e) => setFormData({ ...formData, notes: e.target.value })} rows="2" placeholder="Any notes..."></textarea>
              </div>
            </div>
            <div className="modal-footer">
              <button className="modal-close-btn secondary" onClick={() => { setShowAddModal(false); setEditingExpense(null); resetForm(); }}>Cancel</button>
              <button className="action-btn process" onClick={editingExpense ? handleUpdateExpense : handleCreateExpense}>
                {editingExpense ? 'Update Expense' : 'Create Expense'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading state for form modal */}
      {(showAddModal || editingExpense) && loading && <SkeletonFormModal />}

      {/* View Modal - Updated with Bank Details */}
      {viewingExpense && !loading && (
        <div className="modal-overlay" onClick={() => setViewingExpense(null)}>
          <div className="modal-content1" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '700px', maxHeight: '80vh', overflowY: 'auto' }}>
            <div className="modal-header">
              <h3>Admin Expense Details - {viewingExpense.expenseNumber}</h3>
              <button className="modal-close-btn" onClick={() => setViewingExpense(null)}>×</button>
            </div>
            <div className="modal-body">
              <div className="detail-section">
                <h4>Basic Information</h4>
                <div className="detail-grid">
                  <div className="detail-row"><label>Title:</label><span>{viewingExpense.title}</span></div>
                  <div className="detail-row"><label>Category:</label><span>{getCategoryIcon(viewingExpense.category)} {getCategoryLabel(viewingExpense.category)}</span></div>
                  <div className="detail-row"><label>Department:</label><span>{getDepartmentLabel(viewingExpense.department)}</span></div>
                  <div className="detail-row"><label>Date:</label><span>{new Date(viewingExpense.expenseDate).toLocaleDateString()}</span></div>
                  <div className="detail-row"><label>Priority:</label><span className={`priority-badge ${getPriorityClass(viewingExpense.priority)}`}>{viewingExpense.priority}</span></div>
                </div>
              </div>
              <div className="detail-section">
                <h4>Financial Details</h4>
                <div className="detail-grid">
                  <div className="detail-row"><label>Amount:</label><span>{formatCurrency(viewingExpense.amount)}</span></div>
                  <div className="detail-row"><label>Tax:</label><span>{formatCurrency(viewingExpense.taxAmount)}</span></div>
                  <div className="detail-row"><label>Net Amount:</label><span className="profit">{formatCurrency(viewingExpense.netAmount)}</span></div>
                  <div className="detail-row"><label>Payment Method:</label><span>{viewingExpense.paymentMethod}</span></div>
                  <div className="detail-row"><label>Payment Status:</label><span className={`status-badge ${getStatusBadgeClass(viewingExpense.paymentStatus)}`}>{viewingExpense.paymentStatus}</span></div>
                </div>
              </div>
              <div className="detail-section">
                <h4>Vendor Information</h4>
                <div className="detail-grid">
                  <div className="detail-row"><label>Name:</label><span>{viewingExpense.vendorName || '-'}</span></div>
                  <div className="detail-row"><label>Phone:</label><span>{viewingExpense.vendorPhone || '-'}</span></div>
                </div>
              </div>
              
              {/* Render Bank Details Section */}
              {renderBankDetailsSection()}
              
              <div className="detail-section">
                <h4>Approval Information</h4>
                <div className="detail-grid">
                  <div className="detail-row"><label>Requested By:</label><span>{viewingExpense.requestedBy?.name || '-'}</span></div>
                  <div className="detail-row"><label>Approval Status:</label><span className={`status-badge ${getStatusBadgeClass(viewingExpense.approvalStatus)}`}>{viewingExpense.approvalStatus}</span></div>
                  {viewingExpense.approvedBy && (
                    <div className="detail-row"><label>Approved By:</label><span>{viewingExpense.approvedBy?.name || '-'}</span></div>
                  )}
                  {viewingExpense.rejectionReason && (
                    <div className="detail-row"><label>Rejection Reason:</label><span>{viewingExpense.rejectionReason}</span></div>
                  )}
                </div>
              </div>
              {viewingExpense.notes && (
                <div className="detail-section">
                  <h4>Notes</h4>
                  <div className="detail-row"><span>{viewingExpense.notes}</span></div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="modal-close-btn secondary" onClick={() => setViewingExpense(null)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Loading state for view modal */}
      {viewingExpense && loading && <SkeletonModal />}

      {/* Bank Details Modal */}
      {viewingBankDetails && (
        <BankDetailsModal 
          bankDetails={viewingBankDetails} 
          onClose={() => setViewingBankDetails(null)} 
        />
      )}
    </div>
  );
};

export default AdminExpensesReport;